<template>
  <section>
    <div class="screen">
      <div class="evaluation">
        <div class="evaluation__head">
          <h5 class="evaluation__head-title">{{ $t('evaluation.evaluation') }}</h5>
        </div>
        <div class="evaluation__body">
          <div class="evaluation__choose-student">
            <h5 class="evaluation__item-title">{{ $t('evaluation.selectTheName') }}</h5>
            <div class="p-2">
              <label class="d-block mb-1">{{ $t('evaluation.studentName') }}</label>
              <el-select v-model="studentId" :loading="loading">
                <el-option
                  v-for="student in students"
                  :key="student.id"
                  :label="`${student.firstname} ${student.lastname}`"
                  :value="student.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="evaluation__choose-grade">
            <h5 class="evaluation__item-title">{{ $t('evaluation.chooseGradeStudent') }}</h5>
            <div class="p-2">
              <label class="d-block mb-1">{{ $t('singup.grade') }}</label>
              <el-select v-model="gradeId" placeholder="Select" :disabled="studentId === null">
                <el-option v-for="grade in grades" :key="grade.id" :label="grade.name" :value="grade.id"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="evaluation__choose-subject">
            <h5 class="evaluation__item-title">{{ $t('evaluation.selectThespecific') }}</h5>
            <div class="p-2">
              <label class="d-block mb-1">{{ $t('evaluation.subject') }}</label>
              <el-select v-model="subjectId" placeholder="Select" :disabled="gradeId === null">
                <el-option v-for="subject in subjects" :key="subject.id" :label="subject.name" :value="subject.id">
                </el-option>
              </el-select>
              <div class="mt-2">
                <label class="d-block mb-2">
                  {{ $t('evaluation.typeEvaluation') }}
                </label>
                <el-switch
                  v-model="isFullEvaluation"
                  :active-text="$t('evaluation.fullEvaluation')"
                  :inactive-text="$t('evaluation.lightEvaluation')"
                >
                </el-switch>
              </div>
            </div>
          </div>
        </div>
        <div class="evaluation__footer">
          <button class="btn evaluation__btn-start" @click="startEvaluation">
            {{ $t('evaluation.startTest') }}
            <img src="@/assets/img/arrowNextBook-right.png" alt />
          </button>
        </div>
      </div>
    </div>
    <div v-if="dialogTestVisible" class="evaluation__test">
      <Test
        :grade-id="gradeId"
        :subject-id="subjectId"
        :is-full-evaluation="isFullEvaluation"
        :student-name="studentName"
        :student-id="studentId"
        :grade-name="gradeName"
        @close="dialogTestVisible = false"
      />
    </div>
  </section>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Test from './components/Evaluation.vue';

export default {
  name: 'Evaluation',
  components: {
    Test,
  },
  data() {
    return {
      studentId: null,
      students: [],
      grades: [],
      gradeId: null,
      subjects: [],
      subjectId: null,
      isFullEvaluation: true,
      dialogTestVisible: false,
      loading: false,
    };
  },
  computed: {
    studentName: function () {
      let student = this.students.find(student => this.studentId === student.id);
      return `${student.firstname} ${student.lastname}`;
    },
    gradeName: function () {
      return this.grades.find(grade => this.gradeId === grade.id).name;
    },
    ...mapGetters({
      user: 'auth/authenticatedUser',
    }),
  },
  watch: {
    gradeId: function () {
      this.fetchSubjects();
    },
  },
  created() {
    this.fetchStudents();
    this.fetchGrades();
  },
  methods: {
    fetchStudents() {
      this.$store.commit('app/START_PROCESSING');
      this.loading = true;
      setTimeout(() => {
        this.$httpMain
          .post(`get-all-user-by-rol`, {
            type_user: '1',
            tutor_id: this.user.id,
          })
          .then(res => {
            console.log(res.data);
            res.data.forEach(student => {
              this.students.push({
                ...student,
                firstname: student.firstname.charAt(0).toUpperCase() + student.firstname.slice(1),
                lastname: student.lastname.charAt(0).toUpperCase() + student.lastname.slice(1),
              });
            });
            // this.students = res.data;
          })
          .catch(() => {
            this.students = [];
          })
          .finally(() => {
            this.$store.commit('app/STOP_PROCESSING');
            this.loading = false;
          });
      }, 200);
    },
    fetchGrades() {
      this.$store.commit('app/START_PROCESSING');
      this.$httpMain
        .get(`get_id_name_path_all_grade`)
        .then(res => {
          this.grades = _.remove(res.data, function (grade) {
            return grade.path !== 'preschool' && grade.path !== 'transitional-kinder';
          });
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });
    },
    fetchSubjects() {
      this.$httpMain
        .post(`get_all_subjects_per_grade`, {
          grade_id: this.gradeId,
        })
        .then(res => {
          this.subjects = res.data;
          this.subjects.unshift({ id: 0, name: 'All subjects' });
          this.subjectId = 0;
        });
    },
    startEvaluation() {
      this.dialogTestVisible = true;
    },
  },
};
</script>
<style lang="sass" scoped>
.screen
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  display: flex
  justify-content: center
  align-items: center
  padding: .5em
.evaluation
  max-width: 800px
  width: 100%
  margin: auto
  +element('head')
    color: #fff
    background-color: #b0d529
    padding: 10px 15px
    border-top-left-radius: 10px
    border-top-right-radius: 10px
    font-size: 1.5rem
    font-family: 'comfortaabold'
  +element('body')
    padding: 10px 15px
    background-color: #EDEDED
    font-family: 'comfortaabold'
  +element('item-title')
    color: #265e9b
    margin-top: .8em
  +element('choose-student')
    border-bottom: 3px solid #c389e5
  +element('choose-grade')
    border-bottom: 3px solid #c389e5
  +element('footer')
    padding: 1em 15px
    background-color: #EDEDED
    display: flex
    justify-content: flex-end
    border-bottom-left-radius: 10px
    border-bottom-right-radius: 10px
  +element('btn-start')
    float: right
    width: 139px
    height: 30px
    background-color: #c389e5
    display: flex
    align-items: center
    justify-content: center
    color: #fff
    padding: 4px 0
    img
      width: 10px
      margin-left: 5px
  +element('test')
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    background-color: rgba(64, 157, 164, 0.6)
</style>
